import React from 'react';
import Input from './../../../input';
import Checkbox from 'components/checkbox';

class Download extends React.Component {
  onChange(name, event) {
    this.props.onChange(name, event.target.value);
  }

  render() {
    return (
      <div className="step-container step-five">
        <h2>Almost done!</h2>
        <p>
          All we need now is your email address so we can email you the HTML
          files for your error pages.
        </p>
        <Input
          label="Email address"
          name="emailAddress"
          defaultValue={this.props.send_to_email_address}
          onChange={this.onChange.bind(this, 'send_to_email_address')}
        />
        <p style={{ marginTop: '1.5rem' }}>
          <small>
            By continuing, you agree to our{' '}
            <a
              href="https://www.atlassian.com/legal/privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </a>
            .
          </small>
        </p>
      </div>
    );
  }
}

export default Download;
